import Error from "components/alerts/Error";
import { Text } from "components/common/form/modules/input/Text";
import { TextArea } from "components/common/form/modules/input/TextArea";
import { TimezoneSelect } from "components/common/form/modules/input/TimezoneSelect";
import { closeModal, openModal } from 'components/modal/modules/dispatcher/methods';
import { IUndefinedState } from "lib/interfaces/IUnderfinedState";
import simpleValidation from "lib/utils/simpleValidation";
import moment from "moment";
import React, { Fragment, PureComponent } from "react";
import DatePicker from 'react-datepicker';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import { Prompt } from "react-router";
import Switch from 'react-switch'
import { Card, Col, FormText, Input, Label, Row } from "reactstrap";
import * as yup from "yup";

interface ICreateEventFormProps {
  event: any;
  users: any[];
  onSave: (data: any) => void;
  user: any;
}

class CreateEventForm extends PureComponent<
  ICreateEventFormProps,
  IUndefinedState
  > {
  constructor(props) {
    super(props);
    this.state = {
      event: {
        ...props.event,
        onSale: false,
        agreed: false,
        startTime: moment().hours(21).minutes(0).seconds(0).milliseconds(0),
        endTime: moment().hours(2).minutes(0).seconds(0).milliseconds(0).add(1, 'days'),
        timezoneOffset: (-1 * new Date().getTimezoneOffset() / 60),
        hostName: "",
        time: {
          startYear: 2019,
          startMonth: 1,
          startDay: 1,
          startHour: 12,
          startMinutes: 0,
          startAMPM: true,
          endYear: 2019,
          endMonth: 1,
          endDay: 1,
          endHour: 1,
          endMinutes: 0,
          endAMPM: true
        },
      },
      isChanged: false,
      isValid: true,
      errors: []
    };

    this.isValid = this.isValid.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputChangeLocation = this.handleInputChangeLocation.bind(this);
    this.changeInitialSelection = this.changeInitialSelection.bind(this);
    this.changeSale = this.changeSale.bind(this);
    this.handleStartChange = this.handleStartChange.bind(this);
    this.handleEndChange = this.handleEndChange.bind(this);
    this.showTermsAndConditions = this.showTermsAndConditions.bind(this);
  }

  public componentDidMount() {

    const startTime = new Date();
    const endTime = new Date();
    const e = new Date();

    this.setState({
      startTime,
      endTime,
      event: {
        ...this.state.event,
        time: {
          ...this.state.event.time,
          startYear: e.getFullYear(),
          startMonth: e.getMonth() + 1,
          startDay: e.getDate(),
          startHour: e.getHours() > 12 ? e.getHours() - 12 : e.getHours(),
          startMinutes: 0,
          startAMPM: e.getHours() > 12 ? true : false,
          endYear: e.getFullYear(),
          endMonth: e.getMonth() + 1,
          endDay: e.getDate(),
          endHour: e.getHours() > 12 ? e.getHours() - 12 : e.getHours(),
          endMinutes: 0,
          endAMPM: e.getHours() > 12 ? true : false
        }
      }
    })

  }

  public showTermsAndConditions() {
    const content = <div>
      <p>
        THIS TICKET (“Ticket”) IS A REVOCABLE LICENSE (“License”) SUBJECT TO TERMS AND CONDITIONS ESTABLISHED BY THE VENUE OPERATOR or other authorized entity(ies) (individually, or collectively as the context requires, “Licensor”) in connection with the event identified on the front or main portion of this Ticket (the “Event”) to the licensee of the Ticket (“Licensee”) pursuant to certain terms and conditions as may be established by Licensor, including those set forth below. This Ticket grants the bearer thereof only the right to: (a) enter the publicly-accessible areas of the Event venue (the “Venue”) on dates and at times determined by Licensor; (b) attend the Event; and (c) occupy the seat location identified on the front or main portion of this Ticket during the Event, unless this Ticket has been designated as a “General Admission” Ticket. No resale or offer to resell this Ticket is permitted to the extent prohibited by any applicable federal, state or local law or regulation. Any violation of the terms and conditions shall give Licensor the right to revoke the License immediately without having to refund the established price. Licensor reserves the right to refuse admission or eject any person who violates Licensor’s policies. All persons seeking entry into the Venue specifically consent to and are subject to metal detector and physical pat-down inspections prior to entry and the bearer consents to such searches and waives any related claims that may arise therefrom. If the bearer elects not to consent to such searches, the bearer will be denied entry into the Venue. All bags may be thoroughly inspected. Any person or object that could affect the safety of the Venue, its occupants or its property shall be denied entry. By using this Ticket, each of Licensee or bearer of this Ticket, agrees that: (i): he/she shall not transmit or aid in transmitting any information about the Event, including, but not limited to, any account, description, picture, video, audio, reproduction or other information concerning the Event (collectively, “Event Information”); (ii) Licensor is the exclusive owner of all copyrights and other proprietary rights in the Event and Event Information; and (iii) Licensor and its lawful agents, successors and assigns shall have the unrestricted right and license to use Licensee’s image, likeness, name, voice, comments or other proprietary or public rights and that of any minor accompanying Licensee, in any broadcast, telecast, photograph, video, audio sound, audiovisual and/or other recording taken of, or made in connection with, the Event or other transmission or reproduction, in whole or in part, of the Event, for all purposes, worldwide, in perpetuity and in any and all means and media now or hereafter known, without compensation. The rights granted herein to Licensor are assignable. WAIVER AND RELEASE OF LIABILITY: The bearer recognizes that his/her attendance at the Event is voluntary and may result in personal injury, property damage, or death. The bearer assumes all risk and danger incidental to the Event, and agrees that Licensor, Isotope, Inc., each of the foregoing entities’ respective agencies, departments, subdivisions and each of their officials, directors, agents, players, officers, employees and owners shall not be liable for any personal injury, property loss/damage, or death, whether occurring prior to, during, or after the Event, howsoever caused and whether by negligence or otherwise. This Ticket is not subject to any refund and shall bear no cash value. LICENSEE SHALL HAVE THE RIGHT, IN ITS SOLE DISCRETION, WITHIN TWELVE (12) MONTHS OF THE DATE OF THE SCHEDULED EVENT, TO EXCHANGE THIS TICKET FOR A COMPARABLY PRICED AND SITUATED TICKET TO ATTEND A RESCHEDULED PRESENTATION OF THE SAME EVENT OR ANOTHER SIMILAR EVENT, AS DESIGNATED BY LICENSOR IN ITS SOLE AND ABSOLUTE DISCRETION. GENERAL INFORMATION: 1. This Ticket may not be used for advertising, promotions (including contests and sweepstakes) or other trade or commercial purposes without the express written consent of Licensor. 2. Licensor reserves the right to change all Venue policies without prior notice. 3. In no event will Licensor be liable for any direct, indirect, consequential, exemplary, incidental, special or punitive damages or for lost profits, revenues or business opportunities even if Licensor has been advised of the possibility of such damages. 4. The License shall be governed by the law of the state in which the Venue is located, without giving effect to conflict of laws principles thereof. The exclusive venue for any disputes arising out of the License granted by this Ticket shall be the state or federal courts of the state in which the Venue is located. NO EXCHANGES EXCEPT AS PROVIDED HEREIN. NO CASH VALUE. NO REFUNDS. NO RE-ENTRY.
			</p>
      <br />
      <div className="Seperate-Buttons">
        <button
          className='new-button-white-3'
          style={{ border: 'none' }}
          onClick={e => { closeModal() }}
        >
          DONE
                </button>
      </div>
      <p>
        <br />
      </p>
    </div>
    openModal(content, 'Terms and Conditions')
  }

  public handleStartChange(e) {

    if (e > this.state.endTime) {
      this.setState({
        event: {
          ...this.state.event,
          time: {
            ...this.state.event.time,
            startYear: e.getFullYear(),
            startMonth: e.getMonth() + 1,
            startDay: e.getDate(),
            startHour: e.getHours() > 12 ? e.getHours() - 12 : e.getHours(),
            startMinutes: e.getMinutes(),
            startAMPM: e.getHours() > 12 ? true : false,
            endYear: e.getFullYear(),
            endMonth: e.getMonth() + 1,
            endDay: e.getDate(),
            endHour: e.getHours() > 12 ? e.getHours() - 12 : e.getHours(),
            endMinutes: e.getMinutes(),
            endAMPM: e.getHours() > 12 ? true : false
          }
        },
        startTime: e,
        endTime: e
      })
      return;
    }

    this.setState({
      event: {
        ...this.state.event,
        time: {
          ...this.state.event.time,
          startYear: e.getFullYear(),
          startMonth: e.getMonth() + 1,
          startDay: e.getDate(),
          startHour: e.getHours() > 12 ? e.getHours() - 12 : e.getHours(),
          startMinutes: e.getMinutes(),
          startAMPM: e.getHours() > 12 ? true : false
        }
      },
      startTime: e
    })
  }

  public handleEndChange(e) {

    if (e < this.state.startTime) {
      this.setState({
        event: {
          ...this.state.event,
          time: {
            ...this.state.event.time,
            startYear: e.getFullYear(),
            startMonth: e.getMonth() + 1,
            startDay: e.getDate(),
            startHour: e.getHours() > 12 ? e.getHours() - 12 : e.getHours(),
            startMinutes: e.getMinutes(),
            startAMPM: e.getHours() > 12 ? true : false,
            endYear: e.getFullYear(),
            endMonth: e.getMonth() + 1,
            endDay: e.getDate(),
            endHour: e.getHours() > 12 ? e.getHours() - 12 : e.getHours(),
            endMinutes: e.getMinutes(),
            endAMPM: e.getHours() > 12 ? true : false
          }
        },
        startTime: e,
        endTime: e
      })
      return;
    }

    this.setState({
      event: {
        ...this.state.event,
        time: {
          ...this.state.event.time,
          endYear: e.getFullYear(),
          endMonth: e.getMonth() + 1,
          endDay: e.getDate(),
          endHour: e.getHours() > 12 ? e.getHours() - 12 : e.getHours(),
          endMinutes: e.getMinutes(),
          endAMPM: e.getHours() > 12 ? true : false
        }
      },
      endTime: e
    })
  }

  public handleInputChange(e: any) {
    const { name, value } = e.target;
    this.setState(
      {
        event: {
          ...this.state.event,
          [name]: value
        },
        isChanged: true,
        isValid: true
      }
    );
  }

  public changeSale() {
    this.setState({
      event: {
        ...this.state.event,
        onSale: !this.state.event.onSale
      }
    })

  }

  public changeInitialSelection() {
    this.setState({
      event: {
        ...this.state.event,
        lastInitialOnly: !this.state.event.lastInitialOnly
      }
    })
  }

  public handleInputChangeLocation(e: any) {
    this.setState(
      {
        event: {
          ...this.state.event,
          location: e.description
        },
        isChanged: true,
        isValid: true
      }
    );
  }

  /**
   * Simple validation with YUP.
   * @todo use React Context and create reusable validator
   */
  public isValid() {
    const valid = simpleValidation(
      {
        name: yup
          .string()
          .required(),
        hostName: yup
          .string()
          .required(),
        location: yup
          .string()
          .required(),
        description: yup
          .string()
          .required(),
        timezoneOffset: yup
          .number()
          .required()
          .min(-13)
          .max(13)
      },
      this.state.event
    );

    valid.then((is: any) => {
      if (Object.keys(is).indexOf("errors") === -1) {
        this.props.onSave(this.state.event);
      } else {
        this.setState({ isValid: false, errors: is.errors });
      }
    });
  }

  public renderForm() {

    if (this.state.endTime === undefined) {
      return <div />
    }

    const now = new Date()
    now.setHours(23)
    now.setMinutes(45)

    // For the end time
    // check if same day -> then same restriction otherwise minTime -> 00:00
    const zero = new Date()
    zero.setHours(0);
    zero.setMinutes(0);

    let flag1 = false;
    let flag2 = false;
    const today = new Date();

    if (this.state.startTime.getFullYear() === today.getFullYear()) {
      if (this.state.startTime.getMonth() === today.getMonth()) {
        if (this.state.startTime.getDate() === today.getDate()) {
          flag1 = true;
        }
      }
    }
    if (this.state.endTime.getFullYear() === today.getFullYear()) {
      if (this.state.endTime.getMonth() === today.getMonth()) {
        if (this.state.endTime.getDate() === today.getDate()) {
          flag2 = true;
        }
      }
    }

    return (
      <Fragment>

        <div className='div_holder_2'>
          <div>
            <div>
              <h3 className="sexyBlack">
                Create New Event
        </h3>
              <p className="text-gray">Initialize and setup event.</p>
            </div>
            <div className="big-split-768">
              <Row>
                <Col>
                  <Card style={{ paddingRight: '10%', paddingLeft: '10%' }}>
                    <p />
                    <h3 className="sexyBlack" style={{ width: '100%', textAlign: 'center' }}>Basic Information</h3>
                    <p />

                    <Text
                      label="Name of Event"
                      value={this.state.event.name}
                      name="name"
                      onChange={this.handleInputChange}
                    />
                    <Text
                      label="Host Name"
                      value={this.state.event.hostName}
                      name="hostName"
                      onChange={this.handleInputChange}
                    />
                    <div>
                      <Label>
                        Location
                    </Label>
                      <GooglePlacesAutocomplete
                        onSelect={this.handleInputChangeLocation}
                        placeholder=''
                        inputStyle={{
                          width: '100%',
                          borderRadius: '10px',
                          border: '1px solid #CED4DA',
                          boxShadow: 'none',
                          color: '#495057'
                        }}
                      />
                      <p />
                    </div>
                    <TextArea
                      label="Description"
                      value={this.state.event.description}
                      name="description"
                      onChange={this.handleInputChange}
                    />
                    <p />
                    <div style={{ float: 'left', textAlign: 'center' }}>
                      <div>
                        <div style={{ height: '30px', lineHeight: '40px' }}>
                          <Switch
                            checked={this.state.event.onSale}
                            onChange={this.changeSale}
                            onColor="#4d5adf"
                            onHandleColor="#ffffff"
                            handleDiameter={25}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            boxShadow="0 2px 1px -1px gray"
                            height={25}
                            width={50}
                            className="react-switch"
                            id="material-switch"
                          />
                        </div>
                        <div style={{ height: '20px', lineHeight: '20px' }}>Live</div>
                      </div>
                      <FormText color="muted">Event goes on sale if turned on (payment setup should be completed). You can edit your event even if it is not live.</FormText>
                    </div>
                    <p />
                    <div style={{ float: 'left', textAlign: 'center' }}>
                      <div>
                        <div style={{ height: '30px', lineHeight: '40px' }}>
                          <Switch
                            checked={this.state.event.lastInitialOnly}
                            onChange={this.changeInitialSelection}
                            onColor="#4d5adf"
                            onHandleColor="#ffffff"
                            handleDiameter={25}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            boxShadow="0 2px 1px -1px gray"
                            height={25}
                            width={50}
                            className="react-switch"
                            id="material-switch"
                          />
                        </div>
                        <div style={{ height: '30px', lineHeight: '20px' }}>&nbsp;&nbsp;First Name & Last Initial</div>
                      </div>
                      <FormText color="muted">By default, Isotope collects a ticket buyer's full first and last name. You can change this to first name and last initial. This cannot be changed once the event has been created.</FormText>
                      <p />
                    </div>
                    <div style={{ float: 'left', width: '100%', textAlign: 'center' }}>
                      {!this.state.isValid && this.state.errors.length > 0 ? (
                        <div>
                          {this.state.errors.map(error => (
                            <Error key={error} content={error} />
                          ))}
                        </div>
                      ) : (
                          ""
                        )}
                    </div>
                    <p />
                  </Card>
                  <p><br /></p>
                </Col>
                <Col>
                  <Card>
                    {/* <div className="card-body"> */}
                    <div>
                      <div style={{ paddingRight: '10%', paddingLeft: '10%' }}>
                        <p />
                        <h3 className="sexyBlack" style={{ width: '100%', textAlign: 'center' }}>Time Information</h3>
                        <p />
                        <div >
                          <div style={{ paddingLeft: '10%', paddingRight: '10%' }}>
                            <TimezoneSelect
                              onChange={this.handleInputChange}
                              name="timezoneOffset"
                              value={this.state.event.timezoneOffset}
                              label="Time zone"
                              infoMessage={"Event will no longer be active once it reaches its end time in its time zone."}
                            />
                          </div>
                          <div style={{ textAlign: 'center' }}>
                            <div style={{ width: '50%', float: 'left' }}>
                              <p>Start Time</p>
                              <DatePicker
                                selected={this.state.startTime}
                                onChange={this.handleStartChange}
                                selectsStart={true}
                                startDate={this.state.startTime}
                                endDate={this.state.endTime}
                                // maxDate={this.state.endTime}
                                minDate={new Date()}
                                minTime={flag1 ? new Date() : zero}
                                maxTime={now}

                                showTimeSelect={true}
                                timeFormat="HH:mm"
                                timeIntervals={15}
                                dateFormat="MMMM d, yyyy h:mm aa"
                                timeCaption="time"
                                style={{ width: '100%', border: 'none', backgroundColor: '#ebecf1' }}
                              />
                            </div>
                            <div style={{ width: '50%', float: 'right' }}>
                              <p>End Time</p>
                              <DatePicker
                                selected={this.state.endTime}
                                onChange={this.handleEndChange}
                                selectsEnd={true}
                                startDate={this.state.startTime}
                                endDate={this.state.endTime}
                                minDate={this.state.startTime}

                                minTime={flag2 ? new Date() : zero}
                                maxTime={now}

                                showTimeSelect={true}
                                timeFormat="HH:mm"
                                timeIntervals={15}
                                dateFormat="MMMM d, yyyy h:mm aa"
                                timeCaption="time"
                                style={{ width: '100%', border: 'none', backgroundColor: '#ebecf1' }}
                              />
                            </div>
                          </div>
                          <div style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
                            <div style={{ width: '100%', textAlign: 'center' }}>
                              <div style={{ width: '100%', }}>
                                <br />
                                <Input
                                  type="checkbox"
                                  checked={this.state.agreed}
                                  onChange={e => {
                                    this.setState({
                                      agreed: !this.state.agreed
                                    })
                                  }}
                                  style={{ height: 'auto' }}
                                />
                                <span style={{ paddingLeft: '5px', width: 'auto' }}>
                                  I agree to the &nbsp;
                                  <span style={{ cursor: 'pointer' }}>
                                    <a target="_blank" href="../../../termsandconditions.pdf">terms and conditions</a>
                                  </span>
                                  <br /></span>
                              </div>
                              <p>
                                <br />
                              </p>
                              <button
                                onClick={e => {
                                  e.preventDefault();
                                  this.isValid();
                                }}
                                className='new-button-save'
                                disabled={!this.state.isValid || !this.state.agreed}
                                style={{ border: 'none' }}
                              >
                                Create
                              </button>
                              <p />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <p>
                      <br />
                    </p>
                  </Card>
                </Col>
              </Row>
            </div>
            <div className="small-split-768">
              <Row>
                <Col>
                  <Card style={{ paddingRight: '10%', paddingLeft: '10%' }}>
                    <p />
                    <h3 className="sexyBlack" style={{ width: '100%', textAlign: 'center' }}>Basic Information</h3>
                    <p />

                    <Text
                      label="Name of Event"
                      value={this.state.event.name}
                      name="name"
                      onChange={this.handleInputChange}
                    />
                    <Text
                      label="Host Name"
                      value={this.state.event.hostName}
                      name="hostName"
                      onChange={this.handleInputChange}
                    />
                    <div>
                      <Label>
                        Location
                    </Label>
                      <GooglePlacesAutocomplete
                        onSelect={this.handleInputChangeLocation}
                        placeholder=''
                        inputStyle={{
                          width: '100%',
                          borderRadius: '10px',
                          border: '1px solid #CED4DA',
                          boxShadow: 'none',
                          color: '#495057'
                        }}
                      />
                      <p />
                    </div>
                    <TextArea
                      label="Description"
                      value={this.state.event.description}
                      name="description"
                      onChange={this.handleInputChange}
                    />
                    <p />
                    <div style={{ float: 'left', textAlign: 'center' }}>
                      <div>
                        <div style={{ height: '30px', lineHeight: '40px' }}>
                          <Switch
                            checked={this.state.event.onSale}
                            onChange={this.changeSale}
                            onColor="#4d5adf"
                            onHandleColor="#ffffff"
                            handleDiameter={25}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            boxShadow="0 2px 1px -1px gray"
                            height={25}
                            width={50}
                            className="react-switch"
                            id="material-switch"
                          />
                        </div>
                        <div style={{ height: '20px', lineHeight: '20px' }}>Live</div>
                      </div>
                      <FormText color="muted">Event goes on sale if turned on (payment setup should be completed). You can edit your event even if it is not live.</FormText>
                    </div>
                    <p />
                    <div style={{ float: 'left', textAlign: 'center' }}>
                      <div>
                        <div style={{ height: '30px', lineHeight: '40px' }}>
                          <Switch
                            checked={this.state.event.lastInitialOnly}
                            onChange={this.changeInitialSelection}
                            onColor="#4d5adf"
                            onHandleColor="#ffffff"
                            handleDiameter={25}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            boxShadow="0 2px 1px -1px gray"
                            height={25}
                            width={50}
                            className="react-switch"
                            id="material-switch"
                          />
                        </div>
                        <div style={{ height: '30px', lineHeight: '20px' }}>&nbsp;&nbsp;First Name & Last Initial</div>
                      </div>
                      <FormText color="muted">By default, Isotope collects a ticket buyer's full first and last name. You can change this to first name and last initial. This cannot be changed once the event has been created.</FormText>
                      <p />
                    </div>
                    <div style={{ float: 'left', width: '100%', textAlign: 'center' }}>
                      {!this.state.isValid && this.state.errors.length > 0 ? (
                        <div>
                          {this.state.errors.map(error => (
                            <Error key={error} content={error} />
                          ))}
                        </div>
                      ) : (
                          ""
                        )}
                    </div>
                    <p />
                  </Card>
                  <p><br /></p>
                  <Card>
                    <div>
                      <div style={{ paddingRight: '10%', paddingLeft: '10%' }}>
                        <p />
                        <h3 className="sexyBlack" style={{ width: '100%', textAlign: 'center' }}>Time Information</h3>
                        <p />
                        <div >
                          <div style={{ paddingRight: '10%', paddingLeft: '10%' }}>
                            <TimezoneSelect
                              onChange={this.handleInputChange}
                              name="timezoneOffset"
                              value={this.state.event.timezoneOffset}
                              label="Time zone"
                              infoMessage={"Event will no longer be active once it reaches its end time in its time zone."}
                            />
                          </div>
                          <div style={{ textAlign: 'center' }}>
                            <div style={{ width: '100%' }}>
                              <p>Start Time</p>
                              <DatePicker
                                selected={this.state.startTime}
                                onChange={this.handleStartChange}
                                selectsStart={true}
                                startDate={this.state.startTime}
                                endDate={this.state.endTime}
                                minDate={new Date()}
                                minTime={flag1 ? new Date() : zero}
                                maxTime={now}

                                showTimeSelect={true}
                                timeFormat="HH:mm"
                                timeIntervals={15}
                                dateFormat="MMMM d, yyyy h:mm aa"
                                timeCaption="time"
                                style={{ width: '100%', border: 'none', backgroundColor: '#ebecf1' }}

                              />
                            </div>
                            <p />
                            <div style={{ width: '100%' }}>
                              <p>End Time</p>
                              <DatePicker
                                selected={this.state.endTime}
                                onChange={this.handleEndChange}
                                selectsEnd={true}
                                startDate={this.state.startTime}
                                endDate={this.state.endTime}
                                minDate={this.state.startTime}

                                minTime={flag2 ? new Date() : zero}
                                maxTime={now}

                                showTimeSelect={true}
                                timeFormat="HH:mm"
                                timeIntervals={15}
                                dateFormat="MMMM d, yyyy h:mm aa"
                                timeCaption="time"
                                style={{ width: '100%', border: 'none', backgroundColor: '#ebecf1' }}
                              />
                            </div>
                          </div>
                          <div style={{ paddingLeft: '30px', width: '100%', textAlign: 'center' }}>
                            <br />
                            <Input
                              type="checkbox"
                              checked={this.state.agreed}
                              onChange={e => {
                                this.setState({
                                  agreed: !this.state.agreed
                                })
                              }}
                              style={{ height: 'auto' }}
                            />
                            <span style={{ paddingLeft: '5px' }}>
                              I agree to the &nbsp;
															<span style={{ cursor: 'pointer' }}>
                                <a target="_blank" href="../../../termsandconditions.pdf">terms and conditions</a>
                              </span>
                              <br /></span>
                          </div>
                          <div style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
                            <div>
                              <p>
                                <br />
                              </p>
                              <button
                                onClick={e => {
                                  e.preventDefault();
                                  this.isValid();
                                }}
                                disabled={!this.state.isValid || !this.state.agreed}
                                className='new-button-save'
                                style={{ border: 'none' }}
                              >
                                Create
                              </button>
                              <p />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <p>
                      <br />
                    </p>
                  </Card>
                  <p><br /></p>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }

  public renderPromptOnLeave() {
    return (
      <Prompt
        when={this.state.isChanged}
        message={`Do you want to leave this page without saving your changes ?`}
      />
    );
  }
  public render() {
    return (
      <div>
        {this.renderPromptOnLeave()}
        {this.renderForm()}
      </div>
    );
  }
}


export default CreateEventForm;



// WEBPACK FOOTER //
// ./src/pages/manage/events/create/modules/create.form.tsx